var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price Icon  1",
    clipPath: "url(#clip0_6742_33243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.3622 1.88959C4.23109 1.73604 4.09647 1.5783 3.96229 1.42139C5.73734 -0.066707 8.57224 -0.526938 10.9765 0.722021C13.5317 2.04943 14.5249 4.63756 14.2074 6.73566H13.5725C13.7689 4.36947 12.8875 2.48324 10.6998 1.32196C8.50559 0.156906 6.37097 0.46065 4.3622 1.88959Z",
    fill: "#582CDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9145 10.6717C10.1079 12.0906 7.45012 12.4497 5.19272 11.3644C2.75159 10.1905 1.52949 7.76184 1.75795 5.49635H2.39465C2.29906 7.78785 3.21377 9.59648 5.33567 10.7007C7.46372 11.8083 9.54309 11.5373 11.5115 10.2006C11.6396 10.35 11.7733 10.5069 11.9145 10.6713V10.6717Z",
    fill: "#582CDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.0677 9.54362V7.38342H14.7108V9.53397H15.9996C15.2839 10.3718 14.5968 11.1756 13.8926 12C13.1958 11.1853 12.506 10.3785 11.7922 9.54362H13.0673H13.0677Z",
    fill: "#582CDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 2.6884C0.713001 1.85394 1.40101 1.04927 2.10085 0.230751C2.79719 1.04507 3.48608 1.851 4.19689 2.6821H2.93094V4.85069H1.28174V2.6884H0Z",
    fill: "#582CDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55075 4.82928H6.41087C6.27538 4.82928 6.14558 4.9757 6.14733 5.10366C6.14865 5.22239 6.27581 5.37804 6.41087 5.37804H8.55075C8.54549 5.60878 8.31923 5.957 8.1447 6.12272C7.38127 6.84725 6.65468 6.42352 6.28897 6.61357C6.15698 6.68196 6.11182 6.8569 6.19601 6.99074L6.77877 7.5848C7.18132 7.96993 7.67331 8.49939 8.07805 8.88285C8.14076 8.942 8.164 8.98186 8.22056 9.03849C8.27581 9.09303 8.69064 9.50544 8.75466 9.53271C8.97741 9.6271 9.16202 9.45258 9.16202 9.32588C9.16202 9.13457 9.13527 9.12618 8.94716 8.94662L8.42183 8.42597C8.37404 8.37982 8.33326 8.345 8.28765 8.29801L7.37733 7.37755C7.29533 7.27602 7.18921 7.21561 7.11774 7.11408C7.68515 7.11408 8.19513 6.86362 8.47928 6.58882C8.67266 6.40171 8.75729 6.30941 8.90331 6.08034C8.98969 5.94483 9.14317 5.57942 9.14317 5.37762H9.79303C10.1859 5.37762 10.1434 4.82928 9.83117 4.82928H9.14317C9.14317 4.53016 8.92786 4.1232 8.74764 3.89162L8.5319 3.64116C8.72221 3.64116 9.72857 3.66088 9.86626 3.61976C10.2276 3.51152 10.0785 3.07436 9.81188 3.07436H6.44946C6.09734 3.07436 6.03288 3.54341 6.38632 3.62773C6.75203 3.715 7.44661 3.48257 8.02017 3.96546C8.21092 4.12614 8.28064 4.20082 8.40605 4.41898C8.46744 4.52512 8.54725 4.68371 8.55075 4.82887V4.82928Z",
    fill: "#582CDB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6742_33243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon1);
export default __webpack_public_path__ + "static/media/Price Icon  1.a12db4d15a5de7691b6bab3d29140f23.svg";
export { ForwardRef as ReactComponent };